<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M11.38 20v-1.23h1.24V20zm0-14.77V4h1.24v1.23zM15.08 20v-1.23h1.23V20zm0-14.77V4h1.23v1.23zM18.77 20v-1.23H20V20zm0-3.7v-1.22H20v1.23zm0-3.68v-1.24H20v1.24zm0-3.7V7.7H20v1.23zm0-3.69V4H20v1.23zM4 20v-1h2V5H4V4h5v1H7v14h2v1z"
      />
    </svg>
  </span>
</template>
